import React from 'react';
import Stages from '../../../../../components/common/Stages/Stages';
import { texts } from '../../../../../constants/texts';
import { useSelector } from 'react-redux';
import { useChangeAddressSale } from '../../../../../hooks/useChangeSaleAddress';

const FlatSaleStage = ({ flatsGridQueryKey, sale }) => {
  const currentFlat = useSelector(
    (state) => state.housingStockStore.currentFlat
  );

  const { chengeAsync: chengeSale, loading: loadingSaleChange } =
    useChangeAddressSale();

  const handleMenuClick = (id) => {
    const saleId = Number(id);

    if (saleId !== currentFlat?.addressLifeCycle?.saleAddressLifeCycle?.id) {
      chengeSale({
        flatId: currentFlat?.addressId,
        SaleAddressLifeCycleId: saleId,
        flatsGridQueryKey,
      });
    }
  };

  return (
    <Stages
      loading={loadingSaleChange}
      title={texts.saleStage}
      stages={sale}
      selectedKeys={
        currentFlat?.addressLifeCycle?.saleAddressLifeCycle?.id
          ? [String(currentFlat.addressLifeCycle.saleAddressLifeCycle.id)]
          : []
      }
      onMenuClick={handleMenuClick}
      stageName={
        currentFlat?.addressLifeCycle?.saleAddressLifeCycle?.name || '-'
      }
      type="life"
    />
  );
};

export default FlatSaleStage;
